import { FC } from "react";
import type { OrderDetailsResponse } from "src/Modules/Flights/constants";
import BookingHero from "../newComponents/BookingHero";
import SummaryChip from "../newComponents/SummaryChip";
import FlightSegments from "../newComponents/FlightSegments";
import PassengerDetails from "../newComponents/PassengerDetails";
import TicketDetails from "../newComponents/TicketDetails";

const JourneyResultNewWeb: FC<{ orderDetails: OrderDetailsResponse }> = ({ orderDetails }) => {
  const status = orderDetails.status;
  const leadPassenger = orderDetails.passengers?.find((passenger) => passenger.isLeadPax);
  const email = leadPassenger?.email;
  const hasBookingDetails = !!orderDetails.segments?.length;

  return (
    <div className="flex w-full flex-col items-center">
      <BookingHero status={status} email={email} referenceNumber={orderDetails.orderId} />
      {hasBookingDetails && (
        <div className="flex w-full max-w-7xl flex-col gap-4 px-6 pb-10 md:px-12">
          <SummaryChip orderDetails={orderDetails} />
          <FlightSegments segments={orderDetails.segments} />
          <TicketDetails passengers={orderDetails.passengers} segments={orderDetails.segments} />
          <PassengerDetails passengers={orderDetails.passengers} />
        </div>
      )}
    </div>
  );
};

export default JourneyResultNewWeb;
